<div class='width-800'>

  <mat-card style="padding: 5px; background-color: black;">

    <div class='img-box'>
      <img src="assets/images/geral/sbccv_50.png">
    </div>
    <div class="horizontal-bar-wrap" *ngIf="loading">
      <div class="bar1 bar"></div>
    </div>
  </mat-card>

  <div class="program-wrapper">

    <div class="program-selector">

      <mat-card class='mat-selector'>
        <!--<label>Dia</label>-->
        <mat-select placeholder="Data" [ngModel]='selectedDay' (ngModelChange)='selectDay($event)'>
          <mat-option *ngFor="let day of selectDays" [value]="day.id">
            <span>{{day.name}}</span>
          </mat-option>
        </mat-select>
      </mat-card>

      <mat-card class='mat-selector'>
        <!--<label>Auditório</label>-->
        <mat-select placeholder="Sala" [ngModel]='selectedRoom' (ngModelChange)='selectRoom($event)'>
          <mat-option *ngFor="let room of rooms" [value]="room.id">
            <span>{{room.name}}</span>
          </mat-option>
        </mat-select>
      </mat-card>

      <mat-card class='mat-selector'>
        <!--<label>Departamento</label>-->
        <mat-select placeholder="Atividade" [ngModel]='selectedDepto' (ngModelChange)='selectDepartent($event)'>
          <mat-option *ngFor="let depto of deptos" [value]="depto.id">
            <span>{{depto.short}}</span>
          </mat-option>
        </mat-select>
      </mat-card>

      <mat-card class='mat-selector'>
        <!--<label>Palestrante</label>-->
        <mat-select placeholder="Palestrante" [ngModel]='selectedSpeaker' (ngModelChange)='selectSpeaker($event)'>
          <mat-option *ngFor="let speaker of speakers" [value]="speaker.id">
            <span>{{speaker.name}}</span>
          </mat-option>
        </mat-select>
      </mat-card>

    </div>

    <div class="program-display-wrapper">
      
      <div class="program-display">
        <mat-card style="padding: 5px;">
          <div class="criteria-title">
            {{criteria}}
          </div>
        </mat-card>
      </div>

      <div class="program-display" *ngIf="selectedAtivities.length > 0">

        <mat-card *ngIf="isSpeaker" class='speaker-card'>

          <div class="speaker-box" *ngIf="member_image">
            <div class="speaker-left">
              <img [src]='member_image' *ngIf="member_image">
            </div>
            <div class="speaker-right" [innerHTML]="member_text">
            </div>
          </div>

        </mat-card>

        <mat-card *ngIf="isDepto && depto_text" class='depto-card'>
          <div [innerHTML]="depto_text">
          </div>
        </mat-card>

        <mat-card style="padding: 10px;">

          <div *ngFor="let activity of selectedAtivities">

            <div class="activity-sub-title">
              <span style="color:gold;">{{activity.date_dd_mm}} - {{activity.location}}</span>
            </div>

            <div class="activity-title">
              <div style="color:gold; margin-bottom: 10px;">
                {{activity.depto}}
              </div>
              <a *ngIf="activity.sponsor" target="_blank" [href]="activity.sponsor.link">
                <img style="width:100%; margin: 5px 0 10px 0;" [src]="activity.sponsor.image">
              </a>
              <div>
                {{activity.startTime}} - {{activity.name}}
              </div>
            </div>

            <ul *ngFor="let aga of activity.agenda">
              <div *ngIf="aga.member_name === criteria">
                <li style="color: rgb(165, 127, 2); font-weight: bold;">{{aga.member_name}} - {{aga.role_name}}</li>
              </div>
              <div *ngIf="aga.member_name !== criteria">
                <li> {{aga.member_name}} - {{aga.role_name}}</li>
              </div>
            </ul>

            <div *ngFor="let topic of activity.topics">

              <div class="topic-title">
                <span style="color:gold;">{{topic.startTime}}</span> - {{topic.name}}
              </div>

              <ul *ngFor="let agt of topic.agenda">
                <div *ngIf="agt.member_name === criteria">
                  <li style="color: rgb(165, 127, 2); font-weight: bold;">{{agt.member_name}} - {{agt.role_name}}</li>
                </div>
                <div *ngIf="agt.member_name !== criteria">
                  <li> {{agt.member_name}} - {{agt.role_name}}</li>
                </div>

              </ul>

            </div>

          </div>

        </mat-card>
      </div>

    </div>

  </div>

</div>